import {noop} from 'lodash';

import {notifier} from 'components';

const mock = (message: string) => {
    notifier.info({title: message});
};

const mockAsync = (message: string) => new Promise<void>((resolve) => {
    notifier.info({title: message});
    resolve();
});

const emptyAsync = () => new Promise<void>((resolve) => {
    resolve();
});

export const whiteLabelPreviewEvents = {
    mock,
    mockAsync,
    emptyAsync,
    empty: noop
};